// Auto-generated TypeScript enum from PHP enum

export type TimezoneFormat = 'abbreviation' | 'city' | 'full' | 'offset';

export const TimezoneFormat = {
  Abbreviation: 'abbreviation' as const,
  City: 'city' as const,
  Full: 'full' as const,
  Offset: 'offset' as const,
} as const;

export const TimezoneFormatUtils = {
  values: Object.values(TimezoneFormat),
  keys: Object.keys(TimezoneFormat) as Array<keyof typeof TimezoneFormat>,
  entries: Object.entries(TimezoneFormat) as Array<[keyof typeof TimezoneFormat, TimezoneFormat]>,
  isValid: (value: any): value is TimezoneFormat => Object.values(TimezoneFormat).includes(value),
  fromKey: (key: keyof typeof TimezoneFormat): TimezoneFormat => TimezoneFormat[key],
};

